import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap";
import Stepper from "react-stepper-horizontal";
import { useParams } from "react-router";
import { useFormik } from "formik";
import months from "../data/months";
import MonthlyReportServices from "../../../../services/COOPServices/MonthlyReportServices/MonthlyReportServices";
import ReportTypeServices from "../../../../services/COOPServices/ReportTypeServies/ReportTypeServices";
import SubHeadingServices from "../../../../services/COOPServices/SubHeadingServices/SubHeadingServices";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";
import CustomSelect from "../../../../Components/Common/CustomSelect/CustomSelect";
import Breadcrumbs from "../../../../Components/Common/BreadCrumbs";
import steps from "../data/steps";
import TableComponent from "../components/TableComponent";
import DraftButtons from "../Button/DraftButtons";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import DetailTable from "./DetailTable";
import LanguageToggle from "../LanguageToggleButton/LanguageToggle";
import CommentDetailReport from "./CommentDetailReport";
import ReportCommentServices from "../../../../services/COOPServices/ReportCommentService/ReportCommentService";
import { use } from "i18next";

const DetailReport = () => {
  const [headings, setHeadings] = useState();
  const [reportTypeOption, setReportTypeOption] = useState();
  const [report, setReport] = useState();
  const { id } = useParams();
  console.log("🚀 ~ DraftReport ~ id:", id);

  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const [comments, setComments] = useState([]);
  const fetchComments = async () => {
    try {
      const response = await ReportCommentServices.getById(id);
      setComments(response);
      console.log("🚀 ~ fetchComments ~ response:", response);
    } catch (error) {
      console.log("🚀 ~ fetchComments ~ error:", error);
    }
  };
  console.log("Comments", comments);

  useEffect(() => {
    fetchComments();
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: report?.reportName || "",
      reportTypeId:
        {
          label: report?.reportType.name,
          value: report?.reportType.id,
        } || "",
      year:
        {
          label: report?.year,
          value: report?.year,
        } || "",
      month:
        months.find((item) => item.value === report?.month.toString()) || "",
      remarks: report?.remarks || "",
      // reportTxns:
      //   report?.reportTxns?.map((reportTxn) => {
      //     return {
      //       reportTxnId: reportTxn.reportTxnId,
      //       reportSubTxnDtos: reportTxn?.reportSubTxnDtos?.map((item) => {
      //         return {
      //           subTxnDtos: item.subTxnDtos.map((subItem) => {
      //             return {
      //               reportSubTxnId: subItem.reportSubTxnId,
      //               subHeadingId: subItem.subHeadingId,
      //               credit: subItem.credit,
      //               debit: subItem.debit,
      //             };
      //           }),
      //         };
      //       }),
      //     };
      //   }) || [],
      reportTxns:
        report?.mainHeadings.map((reportTxn) => {
          return {
            reportSubTxnDtos: reportTxn?.reportTxns?.map((item) => {
              return {
                reportTxnId: item.reportTxnId,
                subTxnDtos: item.reportSubTxnDtos?.map((subItem) => {
                  return {
                    reportSubTxnId: subItem.reportSubTxnId,
                    subHeadingId: subItem.subHeadingId,
                    credit: subItem.credit,
                    debit: subItem.debit,
                  };
                }),
              };
            }),
          };
        }) ||
        [
          // {
          //   reportSubTxnDtos: [
          //     {
          //       subHeadingId: 0,
          //       credit: 0,
          //       debit: 0,
          //     },
          //   ],
          // },
        ],
    },
    onSubmit: async (values) => {
      const formattedData = {
        reportId: +id,
        reportName: formik.values.name,
        reportTypeId: values.reportTypeId?.value,
        remarks: values.remarks?.value,
        year: values.year?.value,
        month: values.month?.value.toString(),
        reportTxns: values?.reportTxns?.map((reportTxn) => {
          return {
            reportSubTxnDtos: reportTxn?.reportSubTxnDtos?.map((item) => {
              console.log(
                "🚀 ~ reportSubTxnDtos:reportTxn?.reportSubTxnDtos?.map ~ item:",
                item
              );
              return {
                reportTxnId: item.reportTxnId,
                updateSubTxnDtos: item.subTxnDtos.map((subItem) => {
                  return {
                    reportSubTxnId: subItem.reportSubTxnId,
                    subHeadingId: subItem.subHeadingId,
                    credit: subItem.credit,
                    debit: subItem.debit,
                  };
                }),
              };
            }),
          };
        }),
      };
      try {
        const response = await MonthlyReportServices.submit({
          id: id,
          data: formattedData,
        });
        toast.success("Report Initiated Successfully!");
        fetchReport();
      } catch (error) {
        console.log("🚀 ~ handleInitiateReport ~ error:", error);
      }
    },
  });

  const fetchReportTypeOption = async () => {
    try {
      const response = await ReportTypeServices.getList({
        pageNumber: 1,
        pageSize: 100,
      });
      const temp = response?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setReportTypeOption(temp);
    } catch (error) {
      console.log("🚀 ~ fetchReportTypeOption ~ error:", error);
    }
  };

  const fetchheadings = async () => {
    try {
      const response = await SubHeadingServices.getDisplayList();
      setHeadings(response);
    } catch (error) {
      console.log("🚀 ~ fetchheadings ~ error:", error);
    }
  };

  const fetchReport = async () => {
    try {
      const response = await MonthlyReportServices.getDetail({ reportId: id });
      setReport(response);
    } catch (error) {
      console.log("🚀 ~ fetchReport ~ error:", error);
    }
  };

  useEffect(() => {
    fetchReportTypeOption();
    fetchheadings();
    fetchReport();
  }, [id]);

  const breadcrumbItems = [
    { title: "Reports", link: "/report" },
    { title: "Report Detail" },
  ];

  return (
    <React.Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Container fluid>
          <div className="page-content">
            <Row>
              <Col>
                <Row className="justify-content-between ">
                  <Col>
                    <Breadcrumbs items={breadcrumbItems} />
                  </Col>
                  <Col className="text-end">
                    <button
                      style={{ border: "none", margin: "0", padding: "0" }}
                    >
                      <LanguageToggle
                        toggleVisibility={toggleVisibility}
                        setIsVisible={setIsVisible}
                        isVisible={isVisible}
                      />
                    </button>
                  </Col>
                </Row>
                <Row className="px-2">
                  <Col lg={5}>
                    <Row>
                      <Card className="mt-4">
                        <CardBody className="mt-2">
                          <h6>
                            Submission No. :{" "}
                            <span className="fw-bold">
                              {report?.submissionNum}
                            </span>
                          </h6>
                          <div className="card-width-full">
                            <div className="d-flex flex-column">
                              <h6>
                                Name: <span>{report?.reportName}</span>
                              </h6>
                              <h6>
                                Report Type:{" "}
                                <span>{report?.reportType.name}</span>
                              </h6>
                              <h6>
                                Year: <span>{report?.year}</span>
                              </h6>
                              <h6>
                                Month:{" "}
                                <span>
                                  {
                                    months.find(
                                      (m) =>
                                        m.value.toString() ===
                                        report?.month.toString()
                                    )?.label
                                  }
                                </span>
                              </h6>

                              {(report?.reportStatus === "Acknowledged" ||
                                report?.reportStatus === "Approved") && (
                                <div>
                                  <h6>
                                    Remarks:
                                  </h6>
                                  <h6>{report?.remarks}</h6>
                                </div>
                              )}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      {/* {(report?.reportStatus === "Acknowledged" ||
                        report?.reportStatus === "Approved") && (
                        <Card>
                          <CardTitle className="p-2 text-center align-items-center">
                            Remarks
                          </CardTitle>
                          <CardBody>{report?.remarks}</CardBody>
                        </Card>
                      )} */}
                    </Row>
                  </Col>
                  <Col lg={7} className="px-4 mt-4">
                    <Card
                      style={{
                        width: "100%",
                        height: "223px",
                        paddingTop: "60px",
                      }}
                    >
                      <Stepper
                        steps={steps}
                        activeStep={
                          report?.reportStatus === "Draft"
                            ? 1
                            : report?.reportStatus === "Submitted"
                            ? 2
                            : report?.reportStatus === "Acknowledged"
                            ? 3
                            : 4
                        }
                        className="pt-5 fs-10 mx-auto"
                        activeColor="green"
                        completeColor="green"
                      />
                    </Card>
                  </Col>
                </Row>
                <Row className="px-2">
                  <Row>
                    <Card className="p-0">
                      <CardBody className="pt-1">
                        {headings?.mainHeadings?.map((item, index) => {
                          return (
                            <DetailTable
                              report={report}
                              mainHeading={item}
                              headings={item?.headings}
                              index={index}
                              formik={formik}
                              onWheel={false}
                              isVisible={isVisible}
                              setIsVisible={setIsVisible}
                              toggleVisibility={toggleVisibility}
                            />
                          );
                        })}
                      </CardBody>
                    </Card>
                  </Row>
                </Row>
              </Col>
            </Row>
            <Row>
              <CommentDetailReport
                reportId={id}
                comments={comments}
                fetchComments={fetchComments}
              />
            </Row>
          </div>
        </Container>
      </form>
    </React.Fragment>
  );
};

export default DetailReport;
